import Breadcrumbs from "@/components/common/sections/Breadcrumbs";
import BreadcrumbsImage from "@/assets/images/breadcrumbs/contact-us.webp";

export default function AISolutionsPage() {
	return (
		<>
			<Breadcrumbs
				title="Contact Us"
				subtitle=""
				breadcrumbText="Contact"
				backgroundImage={BreadcrumbsImage}
			/>
		</>
	);
}